<template>
  <div class="company-set" >
    <el-row :span="24" style="margin-bottom: 5px;">
      <div class="top_hint">
        <span class="count">当前公司：<span style="color: red">{{ company.company_name }}</span></span>
      </div>
    </el-row>
    <el-tabs type="border-card" @tab-click="handleClick">
      <el-tab-pane label="基本信息">
        <el-card shadow="always" v-if="company" style="margin-bottom: .2rem;">
          <div slot="header" class="clearfix">
            <span>客户信息</span>
          </div>
          <el-row class="m-tab" style="border-top: 1px solid #dee2e6;">
            <el-col :span="4" class="m-th">
              <el-tooltip content="客户姓名" placement="top" ><span
                  >客户姓名</span></el-tooltip>
            </el-col>
            <el-col :span="4" class="m-td">
              <span>{{ company.customer ? company.customer.name : "" }}</span>
            </el-col>
            <el-col :span="4" class="m-th">
              <el-tooltip content="客户手机" placement="top" ><span
                  >客户手机</span></el-tooltip>
            </el-col>
            <el-col :span="4" class="m-td">
              <span placement="top" >
              {{ company.customer ? company.customer.phone : "" }}</span>
            </el-col>
            <el-col :span="4" class="m-th">
              <el-tooltip content="企业微信群/电话联系记录" placement="top" ><span
                  >企业微信群&nbsp;/&nbsp;电话联系记录</span></el-tooltip>
            </el-col>
            <el-col :span="4" class="m-td">
              <el-button
              type="warning"
              @click="handleWxChatOpen(company.wx_work_chat_com, company.company_name)"
              size="mini"
              icon="el-icon-s-comment"
              circle
              :disabled="company.wx_work_chat_com ? false : true"
              ></el-button>
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-phone-outline"
                circle
                @click="handCallLogsOpen(company)"
              ></el-button>
            </el-col>
          </el-row>
        </el-card>
        <el-card shadow="always" v-if="company" style="margin-bottom: .2rem;">
          <div slot="header" class="clearfix">
            <span>服务人员</span>
          </div>
          <el-row class="m-tab" style="border-top: 1px solid #dee2e6;">
            <el-col :span="4" class="m-th">
              <el-tooltip content="业务员" placement="top" ><span
                  >业务员</span></el-tooltip>
            </el-col>
            <el-col :span="4" class="m-td">{{ company.dedicated_consultant.map(item => item.adminuser ? item.adminuser.username : '').join(', ') }}</el-col>
            <el-col :span="4" class="m-th">
              <el-tooltip content="财税负责人" placement="top" ><span
                  >财税负责人</span></el-tooltip>
            </el-col>
            <el-col :span="4" class="m-td">
              <span>{{ company.leader.map(item => item.adminuser ? item.adminuser.username : '').join(', ') }}</span>
            </el-col>
            <el-col :span="4" class="m-th">
              <el-tooltip content="理票会计" placement="top" ><span
                  >理票会计</span></el-tooltip>
            </el-col>
            <el-col :span="4" class="m-td">
              <span placement="top" >
              {{ company.acc.map(item => item.adminuser ? item.adminuser.username : '').join(', ') }}</span>
            </el-col>
          </el-row>
          <el-row class="m-tab">
            <el-col :span="4" class="m-th">
              <el-tooltip content="客服会计" placement="top" ><span
                  >客服会计</span></el-tooltip>
            </el-col>
            <el-col :span="4" class="m-td">{{ company.ass.map(item => item.adminuser ? item.adminuser.username : '').join(', ') }}</el-col>
            <el-col :span="4" class="m-th">
              <el-tooltip content="记账报税会计" placement="top" ><span
                  >记账报税会计</span></el-tooltip>
            </el-col>
            <el-col :span="4" class="m-td">
              <span>{{ company.advisory.map(item => item.adminuser ? item.adminuser.username : '').join(', ') }}</span>
            </el-col>
            <el-col :span="4" class="m-th">
              <el-tooltip content="开票会计" placement="top" ><span
                  >开票会计</span></el-tooltip>
            </el-col>
            <el-col :span="4" class="m-td">
              <span placement="top" >
              {{ company.invoice.map(item => item.adminuser ? item.adminuser.username : '').join(', ') }}</span>
            </el-col>
          </el-row>
        </el-card>
        <el-card shadow="always" v-if="company">
          <div slot="header" class="clearfix">
            <span>工商信息</span>
          </div>
          <el-row class="m-tab" style="border-top: 1px solid #dee2e6;">
            <el-col :span="4" class="m-th">
              <el-tooltip content="所属园区" placement="top" ><span
                  >所属园区</span></el-tooltip>
            </el-col>
            <el-col :span="4" class="m-td">
              <span>{{ company.address_park }}</span>
            </el-col>
            <el-col :span="4" class="m-th">
              <el-tooltip content="资本类型" placement="top" ><span
                  >资本类型</span></el-tooltip>
            </el-col>
            <el-col :span="4" class="m-td">
              <el-tooltip :content="company.cap_types" placement="top" >{{ company.cap_types
              }}</el-tooltip>
            </el-col>
            <el-col :span="4" class="m-th">
              <el-tooltip content="特殊行业" placement="top" ><span
                  >特殊行业</span></el-tooltip>
            </el-col>
            <el-col :span="4" class="m-td">{{ company.spe_ind }}</el-col>
          </el-row>
          <el-row class="m-tab">
            <el-col :span="4" class="m-th">
              <el-tooltip content="统一社会信用代码" placement="top" ><span
                  >统一社会信用代码</span></el-tooltip>
            </el-col>
            <el-col :span="4" class="m-td">
              <el-tooltip :content="company.cre_code" placement="top" >
                <span >{{ company.cre_code }}</span>
              </el-tooltip>
            </el-col>
            <el-col :span="4" class="m-th">
              <el-tooltip content="注册资本" placement="top" ><span
                  >注册资本</span></el-tooltip>
            </el-col>
            <el-col :span="4" class="m-td">
              <el-tooltip :content="company.regCapital" placement="top" >
                <span >{{ company.regCapital }}</span>
              </el-tooltip>
            </el-col>
            <el-col :span="4" class="m-th">
              <el-tooltip content="企业法人" placement="top" ><span
                  >企业法人</span></el-tooltip>
            </el-col>
            <el-col :span="4" class="m-td">
              <el-tooltip :content="company.legaler" placement="top" >
                <span >{{ company.legaler }}</span>
              </el-tooltip>
            </el-col>
          </el-row>
          <el-row class="m-tab">
            <el-col :span="4" class="m-th">
              <el-tooltip content="联系方式" placement="top" ><span
                  >联系方式</span></el-tooltip>
            </el-col>
            <el-col :span="4" class="m-td">
              <el-tooltip :content="company.legaler_contact" placement="top" >
                <span >{{ company.legaler_contact }}</span>
              </el-tooltip>
            </el-col>
            <el-col :span="4" class="m-th">
              <el-tooltip content="公司类型" placement="top" ><span
                  >公司类型</span></el-tooltip>
            </el-col>
            <el-col :span="4" class="m-td" style="font-size: 12px;line-height: 21px;">
              <el-tooltip :content="company.company_types" placement="top" >
                <span>{{ company.company_types }}</span>
              </el-tooltip>
            </el-col>
            <el-col :span="4" class="m-th">
              <el-tooltip content="小微企业" placement="top" ><span
                  >小微企业</span></el-tooltip>
            </el-col>
            <el-col :span="4" class="m-td">
              <span >{{ isMicroEnt(company.isMicroEnt) }}</span>
            </el-col>
          </el-row>
          <el-row class="m-tab">
            <el-col :span="4" class="m-th">
              <el-tooltip content="行业" placement="top" ><span
                  >行业</span></el-tooltip>
            </el-col>
            <el-col :span="4" class="m-td" style="font-size: 12px;line-height: 21px;">
              <el-tooltip :content="company.trade" placement="top" >
                <span >{{ company.trade }}</span>
              </el-tooltip>
            </el-col>
            <el-col :span="4" class="m-th">
              <el-tooltip content="登记机关" placement="top" ><span
                  >登记机关</span></el-tooltip>
            </el-col>
            <el-col :span="4" class="m-td" style="font-size: 12px;line-height: 21px;">
              <el-tooltip :content="company.reg_auth" placement="top" >
                <span >{{ company.reg_auth }}</span>
              </el-tooltip>
            </el-col>
            <el-col :span="4" class="m-th">
              <el-tooltip content="执照登记地址" placement="top" ><span
                  >执照登记地址</span></el-tooltip>
            </el-col>
            <el-col :span="4" class="m-td">
              <el-tooltip :content="company.reg_address" placement="top" >
                <span >{{ company.reg_address }}</span>
              </el-tooltip>
            </el-col>
          </el-row>
          <el-row class="m-tab">
            <el-col :span="4" class="m-th">
              <el-tooltip content="实际经营地址" placement="top" ><span
                  >实际经营地址</span></el-tooltip>
            </el-col>
            <el-col :span="4" class="m-td" style="font-size: 12px;line-height: 21px;">
              <el-tooltip :content="company.operate_address" placement="top" >
                <span >{{ company.operate_address }}</span>
              </el-tooltip>
            </el-col>
            <el-col :span="4" class="m-th">
              <el-tooltip content="成立日期" placement="top" ><span
                  >成立日期</span></el-tooltip>
            </el-col>
            <el-col :span="4" class="m-td">
              <el-tooltip :content="
                company.date_of_est ? company.date_of_est.substring(0, 10) : ''
              " placement="top" >
                <span >{{
                  company.date_of_est ? company.date_of_est.substring(0, 10) : ""
                }}</span>
              </el-tooltip>
            </el-col>
            <el-col :span="4" class="m-th">
              <el-tooltip content="人员规模" placement="top" ><span
                  >人员规模</span></el-tooltip>
            </el-col>
            <el-col :span="4" class="m-td">
              <span >{{ company.company_scole }}</span>
            </el-col>
          </el-row>
            <el-row class="m-tab">
              <el-col :span="4" class="m-th">
              <el-tooltip content="注册号" placement="top" ><span
                  >注册号</span></el-tooltip>
            </el-col>
            <el-col :span="4" class="m-td">
              <el-tooltip :content="company.regNumber" placement="top" >
                <span >{{ company.regNumber }}</span>
              </el-tooltip>
            </el-col>
            <el-col :span="4" class="m-th">
              <el-tooltip content="营业期限" placement="top" ><span
                  >营业期限</span></el-tooltip>
            </el-col>
            <el-col :span="4" class="m-td">
              <el-tooltip :content="toTime(company.fromTime, company.toTime)" placement="top"
                >
                <span >{{
                  toTime(company.fromTime, company.toTime)
                }}</span>
              </el-tooltip>
            </el-col>
            <el-col :span="4" class="m-th">
              <el-tooltip content="注册地址" placement="top" ><span
                  >注册地址</span></el-tooltip>
            </el-col>
            <el-col :span="4" class="m-td" style="font-size: 12px;line-height: 21px;">
              <el-tooltip :content="company.regLocation" placement="top" >
                <span >{{ company.regLocation }}</span>
              </el-tooltip>
            </el-col>
            </el-row>
            <el-row class="m-tab">
              <el-col :span="4" class="m-th">
              <el-tooltip content="纳税人识别号" placement="top" ><span
                  >纳税人识别号</span></el-tooltip>
            </el-col>
            <el-col :span="4" class="m-td">
              <el-tooltip :content="company.taxNumber" placement="top" >
                <span >{{ company.taxNumber }}</span>
              </el-tooltip>
            </el-col>
            <el-col :span="4" class="m-th">
              <el-tooltip content="组织机构代码" placement="top" ><span
                  >组织机构代码</span></el-tooltip>
            </el-col>
            <el-col :span="4" class="m-td">
              <el-tooltip :content="company.orgNumber" placement="top" >
                <span >{{ company.orgNumber }}</span>
              </el-tooltip>
            </el-col>
            <el-col :span="4" class="m-th">
              <el-tooltip content="企业状态" placement="top" ><span
                  >企业状态</span></el-tooltip>
            </el-col>
            <el-col :span="4" class="m-td">
              <el-tooltip :content="company.regStatus" placement="top" >
                <span >{{ company.regStatus }}</span>
              </el-tooltip>
            </el-col>
            </el-row>
            <el-row class="m-tab">
              <el-col :span="4" class="m-area-th">
              <el-tooltip content="经营范围" placement="top" ><span
                  >经营范围</span></el-tooltip>
            </el-col>
            <el-col :span="20" class="m-area-td">
              <span style="font-size: .26rem;letter-spacing: .04rem;">{{ company.bus_scope }}</span>
            </el-col>
            </el-row>
        </el-card>
      </el-tab-pane>
      <el-drawer
        title="企业微信聊天记录"
        :visible.sync="wxChatDrawer"
        direction="rtl"
        :before-close="handleWxChatBeforeClose"
        size="50%"
      >
        <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
          <el-row>
            <wx-work-chat
              :chatId="wxWorkChatId"
              :chatName="wxWorkchatCompany"
            ></wx-work-chat>
          </el-row>
        </div>
      </el-drawer>
      <el-drawer
        title="电话联系记录"
        :visible.sync="callLogsDrawer"
        direction="rtl"
        :before-close="handleCallLogsBeforeClose"
        size="50%"
      >
        <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
          <el-row>
            <call-logs
              :company="callCompany"
              :phone="callPhone"
              :phone1="callPhone1"
              :phone2="callPhone2"
              :phone3="callPhone3"
            ></call-logs>
          </el-row>
        </div>
      </el-drawer>
      <el-tab-pane label="服务进度">
        服务进度
      </el-tab-pane>
      <el-tab-pane label="订单信息">
        <el-table border size="small" :data="companyBindOrder">
          <el-table-column label="订单编号" prop="order_num" width="200">
            <template slot-scope="scope">
              <el-link type="primary" :underline="false"
                @click="handleOrderInfo(scope.row.id, scope.row.company)">{{ scope.row.order_num }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column label="订单状态" prop="order_status" width="80"></el-table-column>
          <el-table-column label="续费" prop="is_renew" width="50"></el-table-column>
          <el-table-column label="订单顾问" width="60">
            <template slot-scope="scope">
              <span class="count-style" v-if="scope.row.advisor">{{
                scope.row.advisor.username
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="转化人" width="60">
            <template slot-scope="scope">
              <span v-if="scope.row.convert">{{ scope.row.trans.username }}</span>
              <span v-else>自助下单</span>
            </template>
          </el-table-column>
          <el-table-column label="服务人员" prop="operator_name" width="60"></el-table-column>
          <el-table-column label="订单类型" width="110">
            <template slot-scope="scope">
              <el-tooltip v-if="scope.row.order_reg && scope.row.order_reg.order_reg_name === '单品'">
                <span v-if="scope.row.order_reg">
                  {{ scope.row.order_reg.order_reg_name }}:{{ getMeals(scope.row.meal_singles) }}
                </span>
              </el-tooltip>
              <template v-else>
                <span>
                  {{ scope.row.order_reg ? scope.row.order_reg.order_reg_name : "" }}
                </span>
              </template>
            </template>
          </el-table-column>
          <el-table-column label="订单金额" prop="total_amount" width="60"></el-table-column>
          <el-table-column label="园区" prop="order_park" width="60"></el-table-column>
          <el-table-column label="派单时间" prop="assign_at" width="100"></el-table-column>
          <el-table-column label="录入时间" prop="created_at" width="100"></el-table-column>
        </el-table>
        <div class="block" style="margin-top: 10px; text-align: right">
          <el-pagination class="mt-10"
              @current-change="handleCurrentChange"
              :hide-on-single-page="false"
              :current-page.sync="pageOption.currentPage"
              :page-size="pageOption.pageSize"
              layout="total, prev, pager, next"
              :total="pageOption.total"
              background
            >
          </el-pagination>
        </div>
      </el-tab-pane>
      <el-drawer title="订单相关记录" :visible.sync="orderInfoVisible" direction="rtl" size="50%"
        :before-close="handleOrderInfoClose">
        <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
          <order-handle-info :orderId="orderInfoId"></order-handle-info>
        </div>
      </el-drawer>
      <el-tab-pane label="开票信息">
        开票信息
      </el-tab-pane>
      <el-tab-pane label="合同信息">
        合同信息
      </el-tab-pane>
      <el-tab-pane label="待办事项">
        <el-table border :data="serviceInData" style="width: 100%;" size="mini">
          <el-table-column prop="typeiner.username" label="创建人" width="150">
            <template slot-scope="scope">
              <p>{{ scope.row.typeiner.username }}</p>
              <p>{{ scope.row.created_at }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="completed_at" label="ETA处理时间" width="270">
          </el-table-column>
          <el-table-column prop="donner.username" label="办理人" width="120">
            <template slot-scope="scope">
              <div v-if="!scope.row.overTime">
                <span v-if="scope.row.donner">
                  <span>
                    {{ scope.row.donner.username }}
                  </span>
                </span>
              </div>
              <div v-if="scope.row.overTime">
                <span v-if="scope.row.donner">
                  <span>
                    {{ scope.row.donner.username }}
                  </span>
                  <span>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="分配超时"
                      placement="top"
                    >
                      <i
                        class="el-icon-warning"
                        style="
                          font-size: 0.35rem;
                          color: #f56c6c;
                          margin-left: 0.25rem;
                        "
                      ></i>
                    </el-tooltip>
                  </span>
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="donner_w.username" label="外勤办理人" width="120">
            <template slot-scope="scope">
              <div v-if="!scope.row.overTime">
                <span v-if="scope.row.donner_w && scope.row.type === 'w'">{{
                  scope.row.donner_w.username
                }}</span>
              </div>
              <div v-if="scope.row.overTime">
                <span v-if="scope.row.donner_w && scope.row.type === 'w'">
                  <span>{{ scope.row.donner_w.username }}</span>
                  <span>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="分配超时"
                      placement="top"
                    >
                      <i
                        class="el-icon-warning"
                        style="
                          font-size: 0.35rem;
                          color: #f56c6c;
                          margin-left: 0.25rem;
                        "
                      ></i>
                    </el-tooltip>
                  </span>
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="urge_count" label="催办次数" width="120">
            <template slot-scope="scope">
              <div style="padding: 0.28rem 0" v-if="scope.row.urge_count > 0">
                <el-badge :value="scope.row.urge_count" class="item">
                  <!-- <el-button size="mini" @click="openUrgeCount(scope.row.urges)"
                    >催办次数</el-button
                  > -->
                </el-badge>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="feed_count" label="反馈次数" width="80">
          </el-table-column>
          <el-table-column
            prop="feed[0].created_at"
            label="最后一次反馈时间"
            width="160"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="点击查看"
                placement="top"
                v-if="scope.row.feed.length > 0"
              >
                <el-popover placement="right" width="300" trigger="click">
                  <el-row type="flex" class="row-bg" justify="center">
                    <el-col :span="10">反馈人:</el-col>
                    <el-col :span="14" style="font-weight: normal">
                      {{ scope.row.feed[0].feedbacker }}
                    </el-col>
                  </el-row>
                  <el-row type="flex" class="row-bg" justify="center">
                    <el-col :span="10">反馈内容:</el-col>
                    <el-col :span="14" style="font-weight: normal">
                      {{ scope.row.feed[0].feedback }}
                    </el-col>
                  </el-row>
                  <el-row type="flex" class="row-bg" justify="center">
                    <el-col :span="10">预计完成时间:</el-col>
                    <el-col :span="14" style="font-weight: normal">
                      {{ scope.row.feed[0].es_time }}
                    </el-col>
                  </el-row>
                  <i
                    slot="reference"
                    style="cursor: pointer; font-size: 0.28rem; color: #409eff"
                    >{{ scope.row.feed[0].created_at }}</i
                  >
                </el-popover>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="type_name" label="服务类型" width="100">
          </el-table-column>
          <el-table-column prop="order_num" label="订单号" width="190">
            <template slot-scope="scope">
              <span v-if="scope.row.order_num"></span>
              <span v-else style="color: #f56c6c" >无订单号</span>
            </template>
          </el-table-column>
          <el-table-column prop="title_name" label="事项" width="180">
          </el-table-column>
          <el-table-column prop="diser.username" label="分配人" width="150">
            <template slot-scope="scope">
              <p>{{ scope.row.diser.username }}</p>
              <p>{{ scope.row.distribute_at }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="progress" label="进度" width="150">
            <template slot-scope="scope">
              <div v-if="!scope.row.overTimeD">
                <p>{{ scope.row.progress }}</p>
                <p v-if="scope.row.progress === '已完成'">
                  {{ scope.row.done_at }}
                </p>
              </div>
              <div v-if="scope.row.overTimeD">
                <p>
                  <span>{{ scope.row.progress }}</span>
                  <span>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="办理超时"
                      placement="top"
                    >
                      <i
                        class="el-icon-warning"
                        style="
                          font-size: 0.35rem;
                          color: #f56c6c;
                          margin-left: 0.25rem;
                        "
                      ></i>
                    </el-tooltip>
                  </span>
                </p>
                <p v-if="scope.row.progress === '已完成'">
                  {{ scope.row.done_at }}
                </p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="100">
          </el-table-column>
        </el-table>
        <div class="block" style="margin-top: 10px; text-align: right">
          <el-pagination
            @current-change="handleServiceCurrentChange"
            @size-change="handleServiceSizeChange"
            layout="total, prev, pager, next"
            :total="pageServiceOption.total"
            :current-page.sync="pageServiceOption.currentPage"
            :page-size="pageServiceOption.pageSize"
            background
          >
          </el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="快递信息">
        <el-table border :data="expManageData" style="width: 100%; margin-top: 10px" size="mini">
          <el-table-column prop="" label="类型" width="130">
            <template slot-scope="scope">
              <span v-if="scope.row.sor === 's'">
                <el-tag size="mini" type="danger">发件</el-tag>
                <p v-if="scope.row.sor === 's' && scope.row.buy === 'c'">
                  费用付款方：客户
                </p>
                <p v-if="scope.row.sor === 's' && scope.row.buy === 'w'">
                  费用付款方：我方
                </p>
                <p v-if="scope.row.sor === 's' && scope.row.buy === 'd'">
                  费用付款方式：到付
                </p>
                <p v-if="scope.row.sor === 's' && scope.row.is_buy === 1">
                  费用状态：已收取
                </p>
              </span>
              <span v-if="scope.row.sor === 'r'">
                <el-tag size="mini" type="warning">收件</el-tag>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="exp_company" label="快递公司" width="210">
            <template slot-scope="scope">
              <p>{{ scope.row.exp_company }}</p>
              <p>
                <el-tooltip :content="scope.row.exp_num" placement="top">
                  <!-- <span class="hide-style">{{ scope.row.exp_num }}</span> -->
                  <el-link
                    :underline="false"
                    type="primary"
                    @click="handelGetLogistics(scope.row)"
                    >{{ scope.row.exp_num }}</el-link
                  >
                </el-tooltip>
              </p>
              <p>
                <span v-if="scope.row.issign == 1 && scope.row.exp_status != '确认收到'">已经签收</span>
                <span v-else>
                  {{ scope.row.exp_status }}
                </span>
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="exp_phone" label="快递手机号" width="180">
            <template slot-scope="scope">
              <span v-if="scope.row.type === '小程序' && scope.row.sor === 's'">{{
                scope.row.receiver_phone
              }}</span>
              <span v-else>{{ scope.row.exp_phone }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="收件人" width="130">
            <template slot-scope="scope">
              <span v-if="scope.row.sor === 's' && scope.row.type === '小程序'">{{
                "(内部)" + scope.row.qs_receiver
              }}</span>
              <span v-if="scope.row.sor === 'r' && scope.row.receiver_name">{{
                "(内部)" + scope.row.receiver_name
              }}</span>
              <span v-if="scope.row.sor === 's' && scope.row.receiver_s">{{
                "(客户)" + scope.row.receiver_s
              }}</span>
              <span
                v-if="
                  !scope.row.receiver_s &&
                  !scope.row.receiver_name &&
                  scope.row.sor === 'r'
                "
              >
                <span>无收件人</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="exp_content" label="快递内容" width="300">
            <template slot-scope="scope">
              <el-tooltip placement="top-start" popper-class="atooltip">
                <div>{{ scope.row.exp_content }}</div>
                <div slot="content">{{ scope.row.exp_content }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="exp_typeiner" label="录入人" width="150">
            <template slot-scope="scope">
              <span v-if="scope.row.type !== '小程序'">{{
                scope.row.exp_typeiner
              }}</span>
              <span
                v-if="
                  scope.row.type === '小程序' &&
                  scope.row.user &&
                  scope.row.user.nickname
                "
                >{{ "(客户)" + scope.row.user.nickname }}</span
              >
              <span v-if="scope.row.type === '小程序' && scope.row.sor === 's'">{{
                "(客户)" + scope.row.exp_typeiner
              }}</span>
              <p>
                {{ scope.row.type }}
              </p>
              <p>
                {{ scope.row.created_at }}
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="updated_at" label="最后编辑时间" width="180">
          </el-table-column>
        </el-table>
        <div class="block" style="margin-top: 10px; text-align: right">
          <el-pagination
            @current-change="handleExpressCurrentChange"
            @size-change="handleExpressSizeChange"
            layout="total, prev, pager, next"
            :total="pageExpressOption.total"
            :current-page.sync="pageExpressOption.currentPage"
            :page-size="pageExpressOption.pageSize"
            background
          >
          </el-pagination>
        </div>
        <el-drawer
          title="物流信息"
          direction="rtl"
          :visible.sync="expressInfoDrawer"
          :before-close="handExpressInfoClose"
          size="40%"
        >
          <div style="padding: 0 0.2rem">
            <el-timeline v-if="expressInfo.length > 0">
              <el-timeline-item
                class="logistics"
                v-for="(item, index) in expressInfo"
                :key="index"
                :timestamp="item.time"
              >
                {{ item.status }}
              </el-timeline-item>
            </el-timeline>
            <div style="text-align: center" v-else>
              <p>
                <i
                  class="el-icon-info"
                  style="font-size: 1rem; color: #909399 !important"
                ></i>
              </p>
              <p style="margin-top: 0.35rem">
                <span style="color: #909399">信息提示</span>
              </p>
              <p style="margin-top: 0.28rem">
                <span style="color: #909399; font-size: 0.3rem"
                  >系统未查到该快递记录，快递号可能有误，请检查修改！</span
                >
              </p>
            </div>
          </div>
        </el-drawer>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import OrderHandleInfo from 'common/OrderHandleInfo'
import CallLogs from 'common/CallLogs'
import WxWorkChat from 'common/WxWorkChat'
export default {
  name: 'CompanySet',
  components: {
    OrderHandleInfo,
    WxWorkChat,
    CallLogs
  },
  data () {
    return {
      companyId: null,
      company: [],
      companyInfoDrawer: false,
      companyBindOrder: [],
      pageOption: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      orderInfoVisible: false,
      orderInfoId: null,
      serviceInData: [],
      pageServiceOption: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      expManageData: [],
      pageExpressOption: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      wxChatDrawer: false,
      wxWorkChatId: null,
      wxWorkchatCompany: null,
      callLogsDrawer: false,
      callCompany: '',
      callPhone: [],
      callPhone1: [],
      callPhone2: [],
      callPhone3: [],
      expressInfoDrawer: false,
      expressInfo: [],

      foldStyle:{
        marginLeft: '1.25rem !important'
      },
      unFoldStyle:{
        marginLeft: '3.6rem !important'
      }
    }
  },
  created () {
    this.companyId = Number(this.$route.query.company_id)
  },
  computed: {
    actionHost: {
      get: function () {
        return process.env.NODE_ENV === 'development'
          ? ''
          : 'https://weixin.qiyehuo.com'
      }
    },
    collapse () {
      return this.$store.state.collapse
    }
  },
  methods: {
    getCompanyBaseInfo () {
      this.$axios
        .get('/api/admin/get_company_by_id?comId=' + this.companyId)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.company = data.data.company
          }
        })
    },
    getCompanyBindOrder () {
      this.$axios
        .get('/api/admin/get_company_bind_order?page=' +
            this.pageOption.currentPage + '&comId=' + this.companyId)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.companyBindOrder = data.data.companyBindOrder.data
            this.pageOption.total = data.data.companyBindOrder.total
          }
        })
    },
    getCompanyService () {
      this.$axios
        .get('/api/admin/get_company_service?page=' +
            this.pageServiceOption.currentPage + '&comId=' + this.companyId)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.serviceInData = data.data.serviceInData.data
            this.pageServiceOption.total = data.data.serviceInData.total
          }
        })
    },
    getCompanyExpress () {
      this.$axios
        .get('/api/admin/get_company_expdate?page=' +
            this.pageExpressOption.currentPage + '&comId=' + this.companyId)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.expManageData = data.data.expManageData.data
            this.pageExpressOption.total = data.data.expManageData.total
          }
        })
    },
    handleClick (tab) {
      // 监听点击事件
      if (parseInt(tab.index) === 0) {
        this.getCompanyBaseInfo()  // 基本信息
      } else if (parseInt(tab.index) === 1) {
        // 服务进度
      } else if (parseInt(tab.index) === 2) {
        this.getCompanyBindOrder()  // 订单信息
      } else if (parseInt(tab.index) === 3) {
        // 开票信息
      } else if (parseInt(tab.index) === 4) {
        // 合同信息
      } else if (parseInt(tab.index) === 5) {
        this.getCompanyService()  // 待办事项
      } else if (parseInt(tab.index) === 6) {
        this.getCompanyExpress()  // 快递信息
      }
    },
    handleWxChatOpen (chat, companyName) {
      if (chat) {
        this.wxChatDrawer = true
        setTimeout(() => {
          this.wxWorkChatId = chat.chat_id
          this.wxWorkchatCompany = companyName
        })
      }
    },
    handleWxChatBeforeClose (done) {
      this.wxWorkChatId = ''
      this.wxWorkchatCompany = null
      done()
    },
    handCallLogsOpen (row) {
      this.callLogsDrawer = true
      setTimeout(() => {
        this.callCompany = row.company_name
        if (row.user) this.callPhone.push(row.user.phone)
        if (row.docking_phone) this.callPhone3.push(row.docking_phone)
        if (row.tyc_orders.length > 0) {
          for (var i = 0; i < row.tyc_orders.length; i++) {
            if (
              row.tyc_orders[i].customer_phone &&
              this.callPhone1.indexOf(row.tyc_orders[i].customer_phone) === -1
            ) {
              this.callPhone1.push(row.tyc_orders[i].customer_phone)
            }
            if (
              row.tyc_orders[i].corporate_phone &&
              this.callPhone2.indexOf(row.tyc_orders[i].corporate_phone) === -1
            ) {
              this.callPhone2.push(row.tyc_orders[i].corporate_phone)
            }
          }
        }
      })
    },
    handleCallLogsBeforeClose (done) {
      this.callCompany = ''
      this.callPhone = []
      this.callPhone1 = []
      this.callPhone2 = []
      this.callPhone3 = []
      done()
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val
      this.getCompanyBindOrder()
    },
    handleOrderInfo(orderId) {
      this.orderInfoVisible = true
      setTimeout(() => {
        this.orderInfoId = orderId
      })
    },
    handleOrderInfoClose(done) {
      this.orderInfoId = null
      done()
    },
    handleServiceSizeChange (val) {
      this.pageServiceOption.pageSize = val
      this.getCompanyService()
    },
    handleServiceCurrentChange (val) {
      this.pageServiceOption.currentPage = val
      this.getCompanyService()
    },
    handleExpressSizeChange (val) {
      this.pageExpressOption.pageSize = val
      this.getCompanyExpress()
    },
    handleExpressCurrentChange (val) {
      this.pageExpressOption.currentPage = val
      this.getCompanyExpress()
    },
    handelGetLogistics (express) {
      this.$axios
        .get(
          'api/expmanage/getexp?exp_num=' +
            express.exp_num +
            '&exp_company=' +
            express.exp_company +
            '&exp_phone=' +
            express.exp_phone +
            '&id=' +
            express.id
        )
        .then(res => {
          let { data } = res
          if (data.code === 1) {
            this.expressInfo = data.data
            this.expressInfoDrawer = true
          }
        })
    },
    handExpressInfoClose (done) {
      this.expressInfo = []
      this.getCompanyExpress()
      done()
    },
    isMicroEnt(val) {
      let str = ''
      if (val === 1) str = '是'
      if (val === 0) str = '否'
      return str
    },
    toTime(from, to) {
      let time = ''
      if (from) {
        let toTime = to || '无固定期限'
        time = from + ' 至 ' + toTime
      }
      return time
    },
    getMeals(meals) {
      let str = ''
      for (let i = 0; i < meals.length; i++) {
        str += meals[i].item_name + '，'
      }
      return str
    },
  },
  mounted () {
    this.getCompanyBaseInfo()
  }
}
</script>

<style scoped lang="stylus">
@import '~styles/varibles.styl';
@import '~styles/vertical.styl';
@import '~styles/icon.styl';

.company-set {
  marginLeft();
}

.m-tab {
  border-left: 1px solid #dee2e6;
}

.m-th {
  height: 42px;
  line-height: 42px;
  padding: 0 5px;
  border-bottom: 1px solid #dee2e6;
  color: #909399;
  background: #fafafa;
}

.m-td {
  height: 42px;
  line-height: 42px;
  padding: 0 5px;
  border-left: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
}

.m-area-th {
  padding: 0 5px;
  height: 80px;
  line-height: 80px;
  border-bottom: 1px solid #dee2e6;
  color: #909399;
  background: #fafafa;
}

.m-area-td {
  padding: 5px 5px;
  height: 80px;
  border-left: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
  overflow-y: auto;
}

.mt-10 {
  margin-top: .2rem;
}

.top_hint {
  height: 0.8rem;
  line-height: 0.8rem;
  padding-left: .4rem;

  span {
    color: #5787FF;
  }
}

.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}

</style>



// WEBPACK FOOTER //
// src/pages/company_set/CompanySet.vue